import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss']
})
export class MainHeaderComponent implements OnInit {
  headerType = "mainHeader";
  constructor() { }

  ngOnInit(): void {
  }

}
